import React from "react";
import { FlameIcon, GlobeIcon } from "lucide-react";
type ScarcityBarProps = {
  dark?: boolean;
};
export function ScarcityBar({
  dark = false
}: ScarcityBarProps) {
  return <div className="w-full max-w-md" data-id="element-54" data-mp="2l5664n689fxh">
      <div className="mb-2 flex items-center justify-between gap-3 text-sm font-bold" data-id="element-55" data-mp="2l44uaghe0pep">
        <span className={`flex items-center gap-1.5 ${dark ? "text-white" : "text-ink"}`} data-id="element-56" data-mp="2q37rxfv1ftcn">
          <FlameIcon className="h-4 w-4 text-alert" aria-hidden="true" data-id="element-57" data-mp="2b6gxzm44v9uf" />
          Only 7 spots left at this price
        </span>
        <span className="text-alert" data-id="element-58" data-mp="2g7eg5yp583vx">93% claimed</span>
      </div>
      <div className={`h-4 w-full overflow-hidden rounded-full ${dark ? "bg-white/15" : "bg-navy/10"}`} role="progressbar" aria-valuenow={93} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-59" data-mp="226llndyud8st">
        <div className="bar-stripes h-full rounded-full bg-alert" style={{
        width: "93%"
      }} data-id="element-60" data-mp="5drzyhk31ylf" />
      </div>
      <p className={`mt-3 flex items-center justify-center gap-1.5 text-center text-xs ${dark ? "text-white/70" : "text-muted"}`} data-id="element-61" data-mp="33mmuuu6dq9vl">
        <GlobeIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-62" data-mp="2zk8d6deg5g5w" />
        Currency is automatically converted to your local currency at checkout.
      </p>
    </div>;
}